import {
  useState, useMemo,
} from 'react';

// UseCases
import groupOptionsByOptGroup from '../../utils/optGroup/optGroup';

/**
 * @typedef {object} useTableGroupByReturn
 * @property {Array<{lib: string, options: Array<ApiManagerTableFiltersGroupByOptions>}>} groupByOptionsGrouped - The group by options grouped by optGroup
 * @property {Record<string, ApiManagerTableFiltersGroupByOptions>} groupByOptionsId - The group by options grouped by id
 * @property {boolean} popoverGroupByIsOpen - Whether the popover is open
 * @property {(isOpen: boolean) => void} setPopoverGroupByIsOpen - Set the popover open state
 */

/**
 * Hook to manage table group by functionality
 * @param {object} props
 * @param {Array<ApiManagerTableFiltersGroupByOptions>} [props.groupByOptions] - Group by options
 * @returns {useTableGroupByReturn} Group by state and actions
 */
const useTableGroupBy = ({ groupByOptions = [] }) => {
  const [popoverGroupByIsOpen, setPopoverGroupByIsOpen] = useState(false);

  /**
   * @description The group by options grouped by optGroup
   * @type {Array<{lib: string, options: Array<ApiManagerTableFiltersGroupByOptions>}>}
   */
  const groupByOptionsGrouped = useMemo(
    () => groupOptionsByOptGroup(groupByOptions),
    [groupByOptions],
  );

  /**
   * @description The group by options grouped by id
   * @type {Record<string, ApiManagerTableFiltersGroupByOptions>}
   */
  const groupByOptionsId = useMemo(
    () => groupByOptions.reduce((acc, groupByOption) => {
      acc[groupByOption.id] = groupByOption;
      return acc;
    }, /** @type {Record<string, ApiManagerTableFiltersGroupByOptions>} */ ({})),
    [groupByOptions],
  );

  return {
    groupByOptionsId,
    groupByOptionsGrouped,

    // Popover
    popoverGroupByIsOpen,
    setPopoverGroupByIsOpen,
  };
};

export default useTableGroupBy;
